// extracted by mini-css-extract-plugin
export default {"wrapper-event":"HomeEvent_wrapper-event__1Ttuq","btn-right":"HomeEvent_btn-right__8AhY1","btn-left":"HomeEvent_btn-left__wZBHO"};